import { Component, OnInit, AfterViewInit, HostListener, Input, Optional, Inject, ChangeDetectorRef } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormControl, Validators } from "@angular/forms";
import { DialogExampleComponent } from "src/app/dialog-example/dialog-example.component";
import { BundleService } from "src/app/Services/bundleservice.service";
import { DataService } from "src/app/Services/dataservice.service";
import { FlowServiceService } from "src/app/Services/flow-service.service";
import { TitleandmetaserviceService } from "src/app/Services/titleandmetaservice.service";
import { UserserviceService } from "src/app/Services/userservice.service";
import { DeleteBundleDialogComponent } from "../delete-bundle-dialog/delete-bundle-dialog.component";
import { EmbedforbundlesComponent } from "../embedforbundles/embedforbundles.component";
import { ShareEmbedDialogData } from "../embeded/embeded.component";
import { EmbedViewType, generateUrlSlug } from "src/app/utils/embed.util";
import { QRCodeComponent } from "../qrcode/qrcode.component";
import { BundleqrcodeComponent } from "../bundleqrcode/bundleqrcode.component";
import { CommentComponent } from "../comment/comment.component";
import { ReportBundleComponent } from "../report-bundle/report-bundle.component";
import { SupportDocumentComponent } from "../support-document/support-document.component";
import { EnhancedRestrictedAccessComponent } from "../enhanced-restricted-access/enhanced-restricted-access.component";
import { RestrictedforbundleComponent } from "../restrictedforbundle/restrictedforbundle.component";
import { FlowQueryModel } from "src/app/models/flowquerymodel";
import { ShowFlowImageDialogComponent } from "../show-flow-image-dialog/show-flow-image-dialog.component";
import { TransferOwnershipComponent } from "../transfer-ownership/transfer-ownership.component";
import { hasContentCreationPlanAccess } from "src/app/shared/utils/plan.util";
import { BundleTransferWarningDialogComponent } from "../bundle-transfer-warning-dialog/bundle-transfer-warning-dialog.component";
import { ConfirmBundleRemovalDialogComponent } from "../confirm-bundle-removal-dialog/confirm-bundle-removal-dialog.component";
import { AuthModalService } from "src/app/Services/auth-modal.service";
import { OrgContextService } from "src/app/Services/org-context.service";
import { BundleEditorLauncherService } from "src/app/Services/bundle-editor-launcher.service";
import { ContentActivityPanelComponent } from "../content-activity-panel/content-activity-panel.component";
import { VersionHistoryPanelComponent } from "../version-history-panel/version-history-panel.component";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { FlowReviewSubmitComponent } from "../flow-review-submit/flow-review-submit.component";
import { FlowReviewsListModalComponent } from "../flow-reviews-list-modal/flow-reviews-list-modal.component";
import { FlowIssuesDialogComponent } from "../flow-issues-dialog/flow-issues-dialog.component";
import { ReportReviewDialogComponent } from "../report-review-dialog/report-review-dialog.component";
import { FlowCompletionConfirmationComponent } from "../flow-completion-confirmation/flow-completion-confirmation.component";
import { FlowIssueCheckComponent } from "../flow-issue-check/flow-issue-check.component";
import { FlowStepIssuesComponent } from "../flow-step-issues/flow-step-issues.component";
import { FlowThankYouComponent } from "../flow-thank-you/flow-thank-you.component";
import { catchError, take } from "rxjs/operators";
import { forkJoin, Observable, of } from "rxjs";
import { ScheduleViewDialogComponent } from "../schedule-view-dialog/schedule-view-dialog.component";
import { FlowAccessBlockerComponent } from "../flow-access-blocker/flow-access-blocker.component";
import {
  accessBlockTypeFromDenial,
  denialFromHttpError,
} from "src/app/shared/utils/device-access.util";

@Component({
  selector: "app-view-bundle",
  templateUrl: "./view-bundle.component.html",
  styleUrls: ["./view-bundle.component.scss"],
})
export class ViewBundleComponent implements OnInit, AfterViewInit {
  // When opened inside version history preview dialog
  @Input() openInDialog: boolean = false;
  @Input() previewVersion: number | null = null;
  @Input() previewBundleData: any = null;
  @Input() previewUnavailableMessage: string | null = null;
  embedMode = false;
  embedViewType: EmbedViewType = "full";

  get showStandaloneExtras(): boolean {
    return !this.openInDialog && !this.embedMode;
  }

  get showEmbedBundleFlows(): boolean {
    return !this.embedMode || this.embedViewType === "full";
  }

  imageSource: string;
  posterImageSource: string;
  userData: any;
  bundleData: any;
  noResultReturned: boolean;
  likecolor: boolean;
  flowData: any;
  viewCount: number;
  viewText: string;
  bookmarkcolor: string;
  profilePicture: any;
  showDefaultImage: boolean;
  showNotificationCount: boolean;
  email: any;
  phone: any;
  info: any;
  website: any;
  userDisplayName: any;
  uname: any;
  userProfilePicture: any;
  showMenu: boolean;
  videoPlayCounter: any;
  viewUnloaded: any;
  showVideoOrImage: boolean;
  showVideo: boolean;
  isPurchaseRequired: boolean;
  isBundleHomePage: boolean;
  viewsCount: any;
  saveCount: any;
  bundles: any[] = [];
  hasActiveTransferRequest: boolean = false;
  isInitialLoading: boolean = true; // skeleton control
  private isAccessDialogOpen: boolean = false;
  showDescriptionExpanded: boolean = false; // For description expand/collapse
  isMobileView: boolean = false;
  isToggled: boolean = false;
  followButtonText: string = "Follow";
  followingcolor: any;
  followingbgcolor: any;
  showFollow: boolean = true;
  isFollowLoading = false;
  filteredBundleFlows: any[] = [];
  embeddedInBlogs: any[] = [];
  /** True when bundle should show ordered flows + step badges (explicit flag or legacy FlowSequence). */
  bundleFlowsSequenceActive: boolean = false;
  /** Flow list after optional sequence sort (used when search filters / clears). */
  private baseOrderedBundleFlows: any[] = [];
  bundleSearchText: string = "";
  commentsForm: UntypedFormGroup;
  replyForm: UntypedFormGroup;
  comments: any[] = [];
  reply: string = "";
  previousComment: any[] = [];

  /** Reviews (same API as flows; FlowRowKey = bundle row key). */
  flowReviews: any[] = [];
  private _cachedAverageRating = 0;
  private _cachedTotalReviews = 0;
  private _cachedRatingPercentages: { [key: number]: number } = {};
  private _cachedTopReviews: any[] = [];
  private _reviewsCacheValid = false;
  hasUserReviewed = false;
  cachedAverageRating = 0;
  cachedTotalReviews = 0;
  cachedCustomersSaySummary = "";
  cachedReviewsWithImages: any[] = [];
  cachedTopReviews: any[] = [];
  isLoadingReviews = false;
  readonly bundleFeedbackSubtitle =
    "Feedback from people who used this bundle.";

  private readonly videoFileExtensions: string[] = [
    "mp4",
    "mov",
    "wmv",
    "flv",
    "avchd",
    "webm",
    "mkv",
    "vob",
    "ogv",
    "gifv",
    "m4p",
    "m4v",
    "3gp",
    "3g2",
    "amv",
    "nsv",
    "ogg",
    "f4v",
    "f4p",
    "f4a",
    "f4b",
    "avi",
    "mts",
    "m2ts",
    "ts",
    "mpg",
    "mpeg",
    "rm",
    "rmvb",
    "divx",
    "xvid",
    "asf",
    "mxf",
    "dv",
    "h264",
    "h265",
    "vp8",
    "vp9",
    "prores",
    "swf",
    "dat",
    "bik",
    "av1",
    "vro",
    "svi",
  ];
  private readonly imageFileExtensions: string[] = [
    "jpeg",
    "jpg",
    "jfif",
    "png",
    "tiff",
    "tif",
    "gif",
    "bmp",
    "webp",
    "svg",
    "heic",
    "heif",
    "raw",
    "arw",
    "cr2",
    "nef",
    "orf",
    "rw2",
    "dng",
    "psd",
    "ico",
    "exif",
    "pjpeg",
    "ppm",
    "pgm",
    "pbm",
    "pnm",
    "xpm",
    "tga",
    "pcx",
    "jp2",
    "jpx",
    "eps",
    "ai",
  ];

  constructor(
    private bundleService: BundleService,
    private activateRouter: ActivatedRoute,
    private dataService: DataService,
    private userserviceService: UserserviceService,
    private flowServiceService: FlowServiceService,
    private toastr: ToastrService,
    public router: Router,
    public dialog: MatDialog,
    private titleandmetaserviceService: TitleandmetaserviceService,
    public formbuilder: UntypedFormBuilder,
    public authModalService: AuthModalService,
    private cdr: ChangeDetectorRef,
    private orgContextService: OrgContextService,
    private bundleEditorLauncher: BundleEditorLauncherService,
    @Optional() @Inject(MAT_DIALOG_DATA) private dialogData: any,
    @Optional() private dialogRef?: MatDialogRef<ViewBundleComponent>
  ) {
    this.showImage = false;

    // When opened from version preview dialog, initialize inputs immediately
    // so ngOnInit takes preview path and skips route/API path.
    if (this.dialogData?.openInDialog) {
      this.openInDialog = true;
      this.previewVersion = this.dialogData?.previewVersion ?? null;
      this.previewBundleData = this.dialogData?.previewBundleData || null;
      this.previewUnavailableMessage =
        this.dialogData?.previewUnavailableMessage ?? null;
    }
  }

  /** Org Worker / end user in the active org: minimal reader view, no social / sharing actions. */
  get isOrgEndUserView(): boolean {
    return this.orgContextService.isOrgEndUser();
  }

  closePreviewDialog(): void {
    if (this.openInDialog) {
      this.dialogRef?.close();
      return;
    }
    this.dialog.closeAll();
  }

  /** Owner and members of the owning organization can see the activity log. */
  get canViewActivity(): boolean {
    const email = String(this.userData?.emailAddress || "").toLowerCase();
    if (!email || !this.bundleData?.rowKey || this.openInDialog) return false;
    if (String(this.bundleData.customerEmail || "").toLowerCase() === email) return true;
    const orgId = this.bundleData.organizationId || this.bundleData.OrganizationId;
    return this.orgContextService.isActiveMemberOf(orgId);
  }

  openBundleActivityDialog(): void {
    if (!this.bundleData?.rowKey) return;
    ContentActivityPanelComponent.open(this.dialog, {
      contentType: "guidePack",
      contentId: this.bundleData.rowKey,
      title: this.bundleData.title,
    });
  }

  openBundleVersionHistoryDialog(): void {
    const logicalId = this.bundleData?.rowKey;
    if (!logicalId) {
      return;
    }
    const isOwner =
      !!this.userData?.emailAddress &&
      !!this.bundleData?.customerEmail &&
      this.userData.emailAddress === this.bundleData.customerEmail;

    const dialogRef = this.dialog.open(VersionHistoryPanelComponent, {
      width: "640px",
      data: {
        entityType: "bundle",
        logicalId,
        canManageVersions: isOwner,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      const id =
        result?.logicalId || this.bundleData?.rowKey;
      if (
        !result ||
        !id ||
        (result.action !== "restore" && result.action !== "delete")
      ) {
        return;
      }
      this.getBundleDetails(id);
    });
  }

  ngOnInit(): void {
    this.updateIsMobileView();
    // Initialize forms
    this.commentsForm = this.formbuilder.group({
      Comment: new UntypedFormControl("", Validators.required),
    });
    this.replyForm = this.formbuilder.group({
      reply: new UntypedFormControl("", Validators.required),
    });

    this.userData = JSON.parse(localStorage.getItem("LoggedInUser"));

    this.embedMode =
      this.activateRouter.snapshot.data["embedMode"] === true ||
      this.activateRouter.snapshot.url[0]?.path === "embed";

    if (this.embedMode) {
      this.activateRouter.queryParamMap.subscribe((params) => {
        this.embedViewType = (params.get("view") as EmbedViewType) || "full";
        this.cdr.markForCheck();
      });
    }

    // Preview mode (opened in version history dialog): do not reload page or fetch by route.
    if (this.openInDialog) {
      if (!this.previewBundleData) {
        this.bundleData = null;
        this.isInitialLoading = false;
        this.previewUnavailableMessage =
          this.previewUnavailableMessage ||
          "Preview of this version is not available.";
        return;
      }

      this.bundleData = this.previewBundleData;
      // Match standalone view-bundle: keep isToggled false so mobile uses the same DOM as the
      // normal page (flow-layout-container + flow-main-content + recommendations-section-mobile),
      // not mobile-stacked-view.
      this.updateIsMobileView();
      this.isToggled = false;
      this.isInitialLoading = false;
      this.showDescriptionExpanded = false;
      this.applyBundleUiStateForRender(this.bundleData);
      this.loadEmbeddedInBlogs();
      return;
    }

    this.activateRouter.paramMap.subscribe((params) => {
      var bundleId = params.get("id") || params.get("rowKey");
      if (bundleId != null && bundleId != "") this.getBundleDetails(bundleId);
    });
  }

  private applyBundleUiStateForRender(bundleModel: any): void {
    const mediaUrl =
      bundleModel?.url || bundleModel?.Url || "";
    this.posterImageSource =
      bundleModel?.videoThumbNailUrl || bundleModel?.VideoThumbNailUrl || "";
    this.showVideoFromFile(mediaUrl);

    // Order flows by explicit sequence if present; otherwise keep API order.
    const rawFlows = Array.isArray(bundleModel?.flows) ? [...bundleModel.flows] : [];
    const seq =
      bundleModel?.flowSequence ||
      bundleModel?.FlowSequence ||
      bundleModel?.flowsequence ||
      null;

    const seqMap = new Map<string, number>();
    if (Array.isArray(seq)) {
      seq.forEach((s: any) => {
        const id = `${s?.FlowId ?? s?.flowId ?? s?.id ?? ""}`.trim();
        const n = Number(s?.Sequence ?? s?.sequence);
        if (id && Number.isFinite(n)) {
          seqMap.set(id, n);
        }
      });
    }

    const flowsSequencedFlag =
      bundleModel?.flowsSequenced ?? bundleModel?.FlowsSequenced;
    let useSequence = false;
    if (flowsSequencedFlag === false) {
      useSequence = false;
    } else if (flowsSequencedFlag === true) {
      useSequence = seqMap.size > 0;
    } else {
      // Legacy bundles: no explicit flag — treat non-empty FlowSequence as sequenced
      useSequence = seqMap.size > 0;
    }
    this.bundleFlowsSequenceActive = useSequence;

    if (useSequence && seqMap.size > 0) {
      rawFlows.sort((a: any, b: any) => {
        const aId = `${a?.rowKey ?? a?.RowKey ?? ""}`.trim();
        const bId = `${b?.rowKey ?? b?.RowKey ?? ""}`.trim();
        const aSeq = seqMap.get(aId);
        const bSeq = seqMap.get(bId);
        if (aSeq == null && bSeq == null) return 0;
        if (aSeq == null) return 1;
        if (bSeq == null) return -1;
        return aSeq - bSeq;
      });
    }

    this.baseOrderedBundleFlows = rawFlows;
    this.filteredBundleFlows = rawFlows;

    // Match normal page behavior for menu/purchase actions
    if (
      this.userData != null &&
      this.userData.emailAddress != bundleModel?.customerEmail
    ) {
      this.showMenu = true;
      this.isPurchaseRequired = !bundleModel?.isFlowPurchased && !!bundleModel?.isPaid;
    } else if (
      this.userData != null &&
      this.userData.emailAddress == bundleModel?.customerEmail
    ) {
      this.showMenu = false;
      this.isPurchaseRequired = false;
    } else {
      this.showMenu = true;
      this.isPurchaseRequired = !bundleModel?.isFlowPurchased && !!bundleModel?.isPaid;
    }

    // Match normal page like/save indicator mapping
    this.likecolor = bundleModel?.isLiked === "liked";
    this.bookmarkcolor = bundleModel?.isSaved ? "black" : "gray";
  }

  @HostListener("window:resize")
  onResize() {
    this.updateIsMobileView();
  }

  private updateIsMobileView() {
    this.isMobileView =
      (window.innerWidth || document.body.clientWidth) <= 1024;
  }

  ngAfterViewInit() {
    // Intentionally left blank: Do not auto-open Transfer Ownership on page load
  }

  recordPageView() {
    var email = "";
    if (this.userData != null && this.userData != undefined) {
      email = this.userData.emailAddress;
    }

    var getPageViewDetails = {
      ContentId: this.bundleData.rowKey,
      ContentTitle: this.bundleData.title,
      UserEmail: email,
      ContentType: this.bundleData.type,
      ContentUrl: this.bundleData.url,
    };

    this.flowServiceService
      .postPageView(getPageViewDetails)
      .subscribe((res) => {});
  }

  purchaseBundle() {
    var email = "";
    if (this.userData != null && this.userData != undefined) {
      email = this.userData.emailAddress;
    }
    if (
      this.bundleData.price != null &&
      this.bundleData.isPaid &&
      this.userData == null
    ) {
      localStorage.setItem("checkoutFlow", JSON.stringify(this.bundleData));
      // this.router.navigate(['/login'], {
      //   queryParams: { returnUrl: this.router.url }
      // });
      localStorage.setItem("returnUrl", this.router.url);
      this.authModalService.openModal('registration', this.router.url);
    } else if (
      this.bundleData.price != null &&
      this.bundleData.isPaid &&
      !this.bundleData.isFlowPurchased &&
      email != this.bundleData.customerEmail
    ) {
      if (this.userData != null) {
        localStorage.setItem("checkoutFlow", JSON.stringify(this.bundleData));
        this.router.navigate(["/checkout"]);
      } else {
        //   this.router.navigate(['/login'], {
        //   queryParams: { returnUrl: this.router.url }
        // });
        localStorage.setItem("returnUrl", this.router.url);
        this.authModalService.openModal('registration', this.router.url);
      }
    }
  }

  showImage: boolean;
  /** True when showing unpublished edits (`?draft=1`) instead of the published version. */
  isDraftPreview = false;
  getBundleDetails(bundleId) {
    this.noResultReturned = true;
    this.isInitialLoading = true;
    var email = "";
    if (this.userData != null && this.userData != undefined) {
      email = this.userData.emailAddress;
    }

    var flowQueryModel = new FlowQueryModel({
      BundleId: bundleId,
      userEmail: email,
    });

    const draftParam = this.activateRouter.snapshot.queryParamMap.get("draft");
    const wantDraft = !this.openInDialog && (draftParam === "1" || draftParam === "true");

    this.bundleService.getBundleById(flowQueryModel, wantDraft).subscribe(
      (data) => {
        this.noResultReturned = false;

        if (data && data.bundleModel != null) {
          this.bundleData = data.bundleModel;
          this.isDraftPreview = !!(
            data.bundleModel.isPendingDraftView ?? data.bundleModel.IsPendingDraftView
          );
          this.titleandmetaserviceService.setTitle(this.bundleData.title);
          this.applyBundleUiStateForRender(this.bundleData);
          this.viewsCount = this.bundleData.viewsCount;
          this.saveCount = data.bundleModel.saveCount;
          this.showImage = !!(
            this.bundleData.profilePic != null &&
            this.bundleData.profilePic !== ""
          );
          this.isInitialLoading = false;
          this.loadBundleSecondaryData();
        } else {
          if (!this.openInDialog) {
            this.toastr.success(
              "The bundle you are trying to open is no longer available. Explore how-to DIY flows here"
            );
            this.router.navigate(["/"]);
          } else {
            this.toastr.error("Failed to load bundle preview.");
          }
        }
      },
      (error) => {
        this.noResultReturned = false;
        this.isInitialLoading = false;
        if (error?.status === 403) {
          const denial = denialFromHttpError(error);
          this.showBundleAccessBlocker(bundleId, denial);
          return;
        }
        if (this.openInDialog) {
          this.toastr.error("Failed to load bundle preview.");
        } else if (error?.status === 404) {
          this.toastr.success(
            "The bundle you are trying to open is no longer available. Explore how-to DIY flows here"
          );
          this.router.navigate(["/"]);
        } else {
          this.toastr.error("Failed to load bundle.");
        }
      }
    );
  }

  private showBundleAccessBlocker(
    bundleId: string,
    denial: { code: string; message: string }
  ) {
    if (this.isAccessDialogOpen || this.openInDialog) {
      if (this.openInDialog) {
        this.toastr.error(denial.message || "You don't have access to this bundle.");
      }
      return;
    }
    this.isAccessDialogOpen = true;
    localStorage.setItem("flowDataKey", JSON.stringify({ rowKey: bundleId }));
    const type = accessBlockTypeFromDenial(denial.code);
    const dialogRef = this.dialog.open(FlowAccessBlockerComponent, {
      panelClass: "dialoguebox",
      width: "90%",
      maxWidth: "500px",
      maxHeight: "90vh",
      minHeight: "200px",
      disableClose: true,
      hasBackdrop: true,
      backdropClass: "custom-backdrop",
      autoFocus: false,
      restoreFocus: false,
      data: {
        flowId: bundleId,
        isPrivate: type === "private",
        isRestricted: type === "restricted" || type === "advanced",
        isAdvanced: type === "advanced",
        allowRequestAccess: false,
        hasAccess: false,
        denialCode: denial.code,
        denialMessage: denial.message,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.isAccessDialogOpen = false;
      if (result == "go_home") {
        this.router.navigate(["/"]);
      }
    });
  }

  /** Non-blocking follow-up requests after the bundle shell is rendered. */
  private loadBundleSecondaryData(): void {
    this.recordPageView();
    this.CheckIsUserFollowing();
    this.loadComments();
    this.loadEmbeddedInBlogs();

    if (!this.userData) {
      if (this.bundleData?.rowKey && !this.openInDialog) {
        this.loadFlowReviews(this.bundleData.rowKey);
      }
      return;
    }

    const tasks: Record<string, Observable<unknown>> = {};
    if (!this.openInDialog) {
      tasks.profilePic = this.userserviceService.getProfilepic().pipe(
        catchError(() => of(null))
      );
    }
    if (this.bundleData?.rowKey && !this.openInDialog) {
      tasks.reviews = this.flowServiceService
        .getFlowReviews({ FlowRowKey: this.bundleData.rowKey })
        .pipe(catchError(() => of({ reviews: [] })));
    }

    if (Object.keys(tasks).length === 0) {
      return;
    }

    forkJoin(tasks).subscribe((results: any) => {
      const profile = results?.profilePic;
      if (profile?.userData) {
        if (
          profile.userData.profilePicUrl === "" ||
          profile.userData.profilePicUrl == null
        ) {
          this.showDefaultImage = true;
        } else {
          this.showDefaultImage = false;
          this.profilePicture = profile.userData.profilePicUrl;
        }
      }

      const reviewPayload = results?.reviews;
      if (reviewPayload && this.bundleData?.rowKey) {
        this.processBundleReviewsResponse(reviewPayload);
      }
      this.cdr.markForCheck();
    });
  }

  private processBundleReviewsResponse(data: any): void {
    const email = this.userData?.emailAddress ?? "";
    const reviews = (data?.reviews || data || []) as any[];
    this.flowReviews = reviews || [];
    this.hasUserReviewed =
      !!email &&
      reviews.length > 0 &&
      reviews.some(
        (r) => r.email === email || r.CreatedByUserEmail === email
      );
    void this._updateCachedReviewValues();
  }

  onChange() {}

  likeFlow() {
    if (this.userData != null) {
      const previousLikeState = !!this.likecolor;
      const optimisticLikeState = !previousLikeState;

      // Optimistic UI update only for icon state.
      this.likecolor = optimisticLikeState;
      this.cdr.detectChanges();

      const flowModel = {
        PartitionKey: this.bundleData.rowKey,
        LikedByUserEmail: this.userData.emailAddress,
      };

      this.bundleService.LikeBundle(flowModel).subscribe(
        (data) => {
          //this.noResultReturned = false;
          console.log("liked", this.bundleData);
          const totalLikes =
            typeof data.totalLikes === "number" && !isNaN(data.totalLikes)
              ? Math.max(data.totalLikes, 0)
              : 0;
          this.bundleData.likedFlowCount = totalLikes;
          console.log(data);
          if (data.liked === "liked") {
            this.likecolor = true;
            this.showToast();
          } else if (data.liked === "unliked") {
            this.likecolor = false;
            this.showToastForUnlike();
          }
          this.bundleData.likeCount = totalLikes;
          this.viewsCount = data.viewsCount;

          if (this.viewsCount > 1) {
            this.viewText = "Views";
          } else {
            this.viewText = "View";
          }
          this.cdr.detectChanges();

          //
        },
        () => {
          // Roll back optimistic icon state if API call fails.
          this.likecolor = previousLikeState;
          this.cdr.detectChanges();
        }
      );
    } else {
      // this.router.navigate(['/login'], {
      //   queryParams: { returnUrl: this.router.url }
      // });
      localStorage.setItem("returnUrl", this.router.url);
      this.authModalService.openModal('registration', this.router.url);
    }
  }

  showToast() {
    this.toastr.success("Bundle Liked");
  }
  showToastForUnlike() {
    this.toastr.success("Bundle Unliked");
  }

  saveFlow() {
        if (this.userData != null) {
      //
      this.noResultReturned = true;
      const previousBookmarkColor = this.bookmarkcolor;
      const optimisticSaved = this.bookmarkcolor !== "black";
      this.bookmarkcolor = optimisticSaved ? "black" : "gray";
      this.cdr.detectChanges();

      const flowModel = {
        UserEmail: this.userData.emailAddress,
        FlowId: this.bundleData.rowKey,
        FlowType: 2,
      };
      this.flowServiceService.postBookMarkFlow(flowModel).subscribe(
        (data) => {
          this.noResultReturned = false;
          //
          if (data.bookMarked === "bookmarked") {
            this.bookmarkcolor = "black";
            this.showToastforSaved();
          } else if (data.bookMarked === "bookmarkremoved") {
            this.bookmarkcolor = "gray";
            this.showToastforUnsaved();
          }
          this.cdr.detectChanges();
        },
        () => {
          this.noResultReturned = false;
          this.bookmarkcolor = previousBookmarkColor;
          this.cdr.detectChanges();
        }
      );
    } else {
      // this.router.navigate(['/login'], {
      //   queryParams: { returnUrl: this.router.url }
      // });
      localStorage.setItem("returnUrl", this.router.url);
      this.authModalService.openModal('registration', this.router.url);
    }
  }

  showToastforSaved() {
    this.toastr.success("Bundle Saved");
  }
  showToastforUnsaved() {
    this.toastr.success("Bundle Unsaved");
  }
  openImage(url) {
    localStorage.setItem("itemsRequiredImageToShow", url);

    this.dialog.open(ShowFlowImageDialogComponent, {
      panelClass: ["media-dialog-pane", "media-dialog"],
      backdropClass: "custom-backdrop",
      maxWidth: "95vw",
      width: "auto",
      maxHeight: "95vh",
      height: "auto",
      autoFocus: false,
      restoreFocus: false,
    });
  }
  flowClicked(flow) {
    localStorage.setItem("notificationflowId", null);
    //localStorage.setItem("flow", JSON.stringify(flow));
    localStorage.removeItem("flow"); //, JSON.stringify(flow));
    localStorage.setItem("navigateTo", "/");
    if (flow.Type == "Bundle" || flow.type == "Bundle") {
      this.router.navigate(["/view-guide-pack/" + flow.rowKey]);
      return;
    }
    // End users are sent on to task mode by the guide page (after its access checks);
    // `pack` lets task mode return here when they exit.
    const packRowKey = this.bundleData?.rowKey || this.bundleData?.RowKey;
    this.router.navigate(
      [`/guide/${this.generateUrlSlug(flow.title)}/${flow.rowKey}`],
      this.isOrgEndUserView && packRowKey
        ? { queryParams: { pack: packRowKey } }
        : undefined
    );
  }

  loadEmbeddedInBlogs(): void {
    const rowKey = this.bundleData?.rowKey || this.bundleData?.RowKey;
    if (!rowKey) {
      this.embeddedInBlogs = [];
      return;
    }

    this.flowServiceService
      .getBlogsByEmbeddedContent("bundle", rowKey)
      .subscribe({
        next: (data) => {
          this.embeddedInBlogs = Array.isArray(data) ? data : [];
        },
        error: (err) => {
          console.error("Error loading blogs that embed this bundle:", err);
          this.embeddedInBlogs = [];
        },
      });
  }

  getBlogTitleSlug(title: any): string {
    return (title || "").toString().replace(/\s+/g, "-");
  }

  blogClicked(blog: any): void {
    if (!blog) {
      return;
    }
    localStorage.setItem("selectedBlogContent", JSON.stringify(blog));
    this.router.navigate([
      "/blog/" + this.getBlogTitleSlug(blog.title || blog.Title),
    ]);
  }

  openBundleFlowInNewWindow(flow: any, event?: Event): void {
    event?.preventDefault();
    event?.stopPropagation();

    if (!flow?.rowKey) {
      return;
    }

    const baseUrl =
      typeof window !== "undefined" && window.location?.origin
        ? window.location.origin.replace(/\/$/, "")
        : "";

    const isBundle = flow.Type === "Bundle" || flow.type === "Bundle";
    const path = isBundle
      ? `/view-guide-pack/${flow.rowKey}`
      : `/guide/${generateUrlSlug(flow.title || "guide")}/${flow.rowKey}`;

    window.open(`${baseUrl}${path}`, "_blank", "noopener,noreferrer");
  }

  generateUrlSlug(html) {
    if (!html) return "";
    return html
      .replace(/<[^>]*>/g, "") // Remove HTML tags
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "") // Remove accents (é → e, ñ → n)
      .replace(/[^a-zA-Z0-9\s-]/g, "") // Remove special characters except spaces and "-"
      .trim() // Trim spaces from start/end
      .replace(/\s+/g, "-") // Replace spaces with "-"
      .replace(/-+/g, "-") // Remove duplicate dashes
      .toLowerCase(); // Convert to lowercase
  }

  viewUserProfile(selectedFlow) {
    const userFlows = [];
    if (this.userData != null) {
      if (this.userData.emailAddress === selectedFlow.customerEmail) {
        userFlows.push(selectedFlow);
        this.router.navigate(["/user-profile"]);
      } else {
        this.router.navigate(["/view-profile"]);
      }
      this.dataService.flowByCategorieschangeMessage(selectedFlow);
    } else {
      // Open registration modal instead of navigating to page
      this.authModalService.openModal('registration', this.router.url);
    }
  }

  isVideoUrl(url: string): boolean {
    if (!url) {
      return false;
    }
    const extension = this.getExtension(url);
    if (!extension) {
      return false;
    }
    return this.videoFileExtensions.includes(extension.toLowerCase());
  }

  isImageUrl(url: string): boolean {
    if (!url) {
      return false;
    }
    const extension = this.getExtension(url);
    if (!extension) {
      return false;
    }
    return this.imageFileExtensions.includes(extension.toLowerCase());
  }

  getFlowDescription(flow: any): string {
    return (
      flow?.description ||
      flow?.summary ||
      flow?.flowDescription ||
      flow?.flowSummary ||
      ""
    );
  }

  /**
   * Sidebar “flow id” line: prefer human-readable unique code, then unique id if it is not the row key.
   * Avoids showing numeric RowKey when live/preview data exposes uniqueCode / uniqueId.
   */
  bundleFlowCodeDisplay(flow: any): string {
    if (!flow) {
      return "";
    }
    const rk = `${flow.rowKey ?? flow.RowKey ?? ""}`.trim();
    const code = (flow.uniqueCode || flow.UniqueCode || "").toString().trim();
    if (code) {
      return code;
    }
    const uid = `${flow.uniqueId ?? flow.UniqueId ?? ""}`.trim();
    if (uid && uid !== rk) {
      return uid;
    }
    return (
      flow.uniqueCodeWithoutDot ||
      flow.UniqueCodeWithoutDot ||
      ""
    )
      .toString()
      .trim();
  }

  /** Shown in version preview modal — preserves dots in uniqueCode / uniqueId from API. */
  get previewUniqueCodeDisplay(): string {
    if (!this.openInDialog || !this.bundleData) {
      return "";
    }
    const b = this.bundleData;
    const raw =
      b.uniqueCode ||
      b.UniqueCode ||
      b.uniqueId ||
      b.UniqueId ||
      "";
    if (raw) {
      return `${raw}`.trim();
    }
    const noDot =
      b.uniqueCodeWithoutDot ||
      b.UniqueCodeWithoutDot ||
      "";
    return noDot ? `${noDot}`.trim() : "";
  }

  private getExtension(path: string): string {
    if (!path) {
      return "";
    }
    let sanitizedPath = path.split("?")[0].split("#")[0];
    const lastDot = sanitizedPath.lastIndexOf(".");
    if (lastDot === -1 || lastDot === sanitizedPath.length - 1) {
      return "";
    }
    return sanitizedPath.substring(lastDot + 1);
  }

  getProfilepic(): void {
    if (this.userData != null) {
      this.userserviceService.getProfilepic().subscribe((data) => {
        if (
          data.userData.profilePicUrl === "" ||
          data.userData.profilePicUrl == null
        ) {
          this.showDefaultImage = true;
        } else {
          this.showDefaultImage = false;
          this.profilePicture = data.userData.profilePicUrl;
        }
      });
    }
  }

  getProfileUser(): void {
    if (this.userData != null) {
      //
      this.noResultReturned = true;
      this.showNotificationCount = true;
      this.userserviceService.getProfileUser().subscribe((data) => {
        this.noResultReturned = false;

        if (
          data.userData.profilePicUrl === "" ||
          data.userData.profilePicUrl == null
        ) {
          //
          this.showDefaultImage = true;
        } else {
          this.showDefaultImage = false;
          this.profilePicture = data.userData.profilePicUrl;
        }
        this.email = data.userData.emailAddress;
        this.phone = data.userData.phoneNumber;
        this.info = data.userData.info;
        this.website = data.userData.website;
        this.userDisplayName = this.uname = data.userData.userName;
        this.uname = data.userData.firstName;
      });
    }
  }

  ViewSupportingDocuments() {
    if (this.bundleData.isPaid && this.userData == null) {
      // this.router.navigate(['/login'], {
      //   queryParams: { returnUrl: this.router.url }
      // });
      localStorage.setItem("returnUrl", this.router.url);
      this.authModalService.openModal('registration', this.router.url);
    } else {
      //this.router.navigate(["/in-Appropriate"]);
      localStorage.setItem("flowData", JSON.stringify(this.bundleData));
      const dialogRef = this.dialog.open(SupportDocumentComponent, {
        panelClass: "dialoguebox",
      });
      dialogRef.afterClosed().subscribe((result) => {});
    }
  }

  onChatClick() {
    if (this.userData != null) {
      localStorage.setItem(
        "bundlecommentData",
        JSON.stringify(this.bundleData)
      );
      localStorage.removeItem("flowcommentData");
      localStorage.setItem("FromBundleData", "yes");
      //  this.router.navigate(["/comment"]);
      // this.router.navigate(["/guide-pack-qrcode"]);
      const dialogRef = this.dialog.open(CommentComponent, {
        panelClass: "dialoguebox",
      });
      dialogRef.afterClosed().subscribe((result) => {
        this.noResultReturned = false;
      });
    } else {
      // this.router.navigate(['/login'], {
      //   queryParams: { returnUrl: this.router.url }
      // });
      localStorage.setItem("returnUrl", this.router.url);
      this.authModalService.openModal('registration', this.router.url);
    }
  }
  InAppropriate() {
    if (this.userData != null) {
      localStorage.setItem("bundleData", JSON.stringify(this.bundleData));
      //this.router.navigate(["/report-guide-pack"]);
      const dialogRef = this.dialog.open(ReportBundleComponent, {
        panelClass: "dialoguebox",
      });
      dialogRef.afterClosed().subscribe((result) => {});
    } else {
      // this.router.navigate(['/login'], {
      //   queryParams: { returnUrl: this.router.url }
      // });
      localStorage.setItem("returnUrl", this.router.url);
      this.authModalService.openModal('registration', this.router.url);
    }
  }

  openReviewsModal() {
    if (!this.bundleData) {
      return;
    }
    this.dialog.open(FlowReviewsListModalComponent, {
      width: "800px",
      maxWidth: "90vw",
      data: { flowData: this.bundleData },
      panelClass: "dialoguebox",
    });
  }

  openScheduleView(): void {
    if (!this.userData) {
      localStorage.setItem("returnUrl", this.router.url);
      this.authModalService.openModal("registration", this.router.url);
      return;
    }
    if (!this.bundleData) {
      return;
    }

    this.dialog.open(ScheduleViewDialogComponent, {
      width: "520px",
      maxWidth: "95vw",
      panelClass: "dialoguebox",
      data: {
        entityType: "bundle",
        title: this.bundleData?.title || "Bundle",
        linkUrl: window?.location?.href,
      },
    });
  }

  openReviewDialog() {
    if (!this.userData) {
      localStorage.setItem("returnUrl", this.router.url);
      this.authModalService.openModal("registration", this.router.url);
      return;
    }

    if (!this.bundleData?.rowKey) {
      this.toastr.error("Unable to submit review for this bundle.");
      return;
    }

    if (
      this.bundleData.price != null &&
      this.bundleData.isPaid &&
      !this.bundleData.isFlowPurchased &&
      this.userData.emailAddress !== this.bundleData.customerEmail
    ) {
      this.toastr.info("Please purchase this bundle to leave a review.");
      localStorage.setItem("checkoutFlow", JSON.stringify(this.bundleData));
      this.router.navigate(["/checkout"]);
      return;
    }

    if (this.hasUserReviewed) {
      this.toastr.info("You have already reviewed this bundle.");
      return;
    }

    this.showBundleCompletionFlow();
  }

  private showBundleCompletionFlow(): void {
    const completionDialogRef = this.dialog.open(
      FlowCompletionConfirmationComponent,
      {
        width: "500px",
        maxWidth: "90vw",
        data: { flowData: this.bundleData, contentType: "bundle" },
        disableClose: false,
        panelClass: "dialoguebox",
      }
    );

    completionDialogRef.afterClosed().subscribe((completionResult) => {
      if (completionResult?.stuck === true) {
        this.openBundleIssueAndReviewFlow();
        return;
      }

      if (completionResult?.completed === false) {
        this.dialog.open(FlowThankYouComponent, {
          width: "500px",
          maxWidth: "90vw",
          data: { flowData: this.bundleData, contentType: "bundle" },
          panelClass: "dialoguebox",
        });
        return;
      }

      if (completionResult?.completed === true) {
        const issueCheckDialogRef = this.dialog.open(FlowIssueCheckComponent, {
          width: "500px",
          maxWidth: "90vw",
          data: { flowData: this.bundleData, contentType: "bundle" },
          panelClass: "dialoguebox",
        });

        issueCheckDialogRef.afterClosed().subscribe((issueResult) => {
          if (issueResult?.hasIssues === true) {
            this.openBundleIssueAndReviewFlow();
            return;
          }

          if (issueResult?.hasIssues === false) {
            this.openBundleReviewSubmitDialog(false, []);
          }
        });
      }
    });
  }

  private openBundleIssueAndReviewFlow(): void {
    const issueFlowData = this.getBundleIssueFlowData();
    if (!this.hasBundleStepData(issueFlowData)) {
      this.toastr.info(
        "Issue reporting is not available for this bundle. You can still leave a review."
      );
      this.openBundleReviewSubmitDialog(true, []);
      return;
    }

    const stepIssuesDialogRef = this.dialog.open(FlowStepIssuesComponent, {
      width: "800px",
      maxWidth: "90vw",
      maxHeight: "90vh",
      data: { flowData: issueFlowData, contentType: "bundle" },
      panelClass: "dialoguebox",
    });

    stepIssuesDialogRef.afterClosed().subscribe((issuesResult) => {
      if (issuesResult?.issues && issuesResult.issues.length > 0) {
        this.openBundleReviewSubmitDialog(true, issuesResult.issues);
        return;
      }

      if (issuesResult?.skip === true) {
        this.openBundleReviewSubmitDialog(false, []);
      }
    });
  }

  private hasBundleStepData(issueFlowData: any): boolean {
    return (
      Array.isArray(issueFlowData?.steps) &&
      issueFlowData.steps.length > 0
    );
  }

  private getBundleIssueFlowData(): any {
    if (Array.isArray(this.bundleData?.steps) && this.bundleData.steps.length > 0) {
      return this.bundleData;
    }

    const sourceFlows =
      this.baseOrderedBundleFlows?.length > 0
        ? this.baseOrderedBundleFlows
        : Array.isArray(this.bundleData?.flows)
          ? this.bundleData.flows
          : [];

    const derivedSteps = sourceFlows.map((flow: any, index: number) => ({
      title: flow?.title || flow?.name || `Flow ${index + 1}`,
    }));

    return {
      ...this.bundleData,
      steps: derivedSteps,
    };
  }

  private openBundleReviewSubmitDialog(
    hasIssues: boolean,
    issues: any[] = []
  ): void {
    const reviewDialogRef = this.dialog.open(FlowReviewSubmitComponent, {
      width: "900px",
      maxWidth: "95vw",
      panelClass: "dialoguebox",
      data: {
        flowData: this.bundleData,
        fromIssue: hasIssues,
        contentType: "bundle",
      },
      disableClose: true,
    });

    reviewDialogRef.afterClosed().subscribe((reviewResult) => {
      if (reviewResult) {
        this.submitBundleReview(reviewResult, hasIssues, issues);
      }
    });
  }

  private submitBundleReview(
    reviewData: any,
    hasIssues: boolean = false,
    issues: any[] = []
  ) {
    const reviewModel = {
      FlowRowKey: this.bundleData.rowKey,
      ReviewerEmail: this.userData?.emailAddress,
      IsCompleted: true,
      Rating: reviewData?.rating || 0,
      ReviewText: reviewData?.reviewText || null,
      HasIssues: hasIssues,
      Issues: issues,
      MediaUrl: reviewData?.mediaUrl || null,
      MediaThumbnailUrl: reviewData?.mediaThumbnailUrl || null,
      IsVideo: reviewData?.isVideo || false,
    };

    this.flowServiceService.createFlowReview(reviewModel).subscribe({
      next: () => {
        this.toastr.success("Thank you! Your review has been submitted.");
        if (this.bundleData?.rowKey) {
          this.loadFlowReviews(this.bundleData.rowKey);
        }
        this.cdr.markForCheck();
      },
      error: () => {
        this.toastr.error("Failed to submit review. Please try again.");
      },
    });
  }

  isBundleOwner(): boolean {
    return (
      !!this.userData?.emailAddress &&
      !!this.bundleData?.customerEmail &&
      this.userData.emailAddress === this.bundleData.customerEmail
    );
  }

  /**
   * Load reviews for this bundle (same endpoint as flows; FlowRowKey = bundle id).
   */
  loadFlowReviews(bundleRowKey: string): void {
    if (!bundleRowKey) {
      this.flowReviews = [];
      this._resetCachedReviewValues();
      this.cdr.markForCheck();
      return;
    }

    this.isLoadingReviews = true;
    this.hasUserReviewed = false;
    const email = this.userData?.emailAddress ?? "";

    this.flowServiceService
      .getFlowReviews({ FlowRowKey: bundleRowKey })
      .pipe(
        take(1),
        catchError((err) => {
          console.error("Error loading bundle reviews:", err);
          this.isLoadingReviews = false;
          this.flowReviews = [];
          this._resetCachedReviewValues();
          this.cdr.markForCheck();
          return of({ reviews: [] });
        })
      )
      .subscribe(async (data: any) => {
        try {
          if (!data) {
            this.flowReviews = [];
            await this._updateCachedReviewValues();
            this.isLoadingReviews = false;
            this.cdr.markForCheck();
            return;
          }
          const reviews = (data.reviews || data || []) as any[];
          this.flowReviews = reviews || [];
          this.hasUserReviewed =
            !!email &&
            reviews.length > 0 &&
            reviews.some(
              (r) =>
                r.email === email || r.CreatedByUserEmail === email
            );
          await this._updateCachedReviewValues();
          this.cdr.markForCheck();
        } catch (e) {
          console.error("Error processing bundle reviews:", e);
          this.flowReviews = [];
          await this._resetCachedReviewValues();
          this.cdr.markForCheck();
        } finally {
          this.isLoadingReviews = false;
          this.cdr.markForCheck();
        }
      });
  }

  private async _updateCachedReviewValues(): Promise<void> {
    if (!this.flowReviews || this.flowReviews.length === 0) {
      this._resetCachedReviewValues();
      return;
    }
    await this._calculateRatings();
    await this._delay(0);
    this._cachedTotalReviews = this.flowReviews.length;
    this.cachedTotalReviews = this._cachedTotalReviews;
    await this._delay(0);
    this._cachedTopReviews = [...this.flowReviews].sort((a, b) => {
      if (b.rating !== a.rating) {
        return (b.rating || 0) - (a.rating || 0);
      }
      const dateA = new Date(a.createdDate || 0).getTime();
      const dateB = new Date(b.createdDate || 0).getTime();
      return dateB - dateA;
    });
    this.cachedTopReviews = this._cachedTopReviews;
    this.cachedReviewsWithImages = this.flowReviews.filter(
      (r) => r.mediaUrl && `${r.mediaUrl}`.trim() !== ""
    );
    this.cachedCustomersSaySummary = this._bundleReviewSummary();
    this._reviewsCacheValid = true;
    this.cdr.markForCheck();
  }

  private _resetCachedReviewValues(): void {
    this._cachedAverageRating = 0;
    this._cachedTotalReviews = 0;
    this._cachedRatingPercentages = {};
    this._cachedTopReviews = [];
    this._reviewsCacheValid = true;
    this.cachedAverageRating = 0;
    this.cachedTotalReviews = 0;
    this.cachedCustomersSaySummary = "";
    this.cachedReviewsWithImages = [];
    this.cachedTopReviews = [];
    this.cdr.markForCheck();
  }

  private async _calculateRatings(): Promise<void> {
    const withRating = this.flowReviews.filter((r) => r.rating && r.rating > 0);
    if (withRating.length === 0) {
      this._cachedAverageRating = 0;
      this.cachedAverageRating = 0;
      return;
    }
    const sum = withRating.reduce((acc, r) => acc + (r.rating || 0), 0);
    this._cachedAverageRating =
      Math.round((sum / withRating.length) * 10) / 10;
    this.cachedAverageRating = this._cachedAverageRating;
    this._cachedRatingPercentages = {};
    for (let star = 1; star <= 5; star++) {
      const count = withRating.filter((r) => r.rating === star).length;
      this._cachedRatingPercentages[star] =
        withRating.length > 0
          ? Math.round((count / withRating.length) * 100)
          : 0;
    }
  }

  private _bundleReviewSummary(): string {
    if (!this.flowReviews?.length) {
      return "";
    }
    const avg = this._cachedAverageRating;
    const n = this.flowReviews.length;
    const lines: string[] = [];
    if (avg >= 4) {
      lines.push(
        `This bundle has strong feedback (${avg.toFixed(1)}/5 from ${n} review${n > 1 ? "s" : ""}).`
      );
    } else if (avg >= 3) {
      lines.push(
        `Reviewers rate this bundle ${avg.toFixed(1)}/5 on average (${n} review${n > 1 ? "s" : ""}).`
      );
    } else {
      lines.push(
        `This bundle has mixed feedback (${avg.toFixed(1)}/5 from ${n} review${n > 1 ? "s" : ""}).`
      );
    }
    return lines.join(" ").trim() || "Customers have shared their experiences with this bundle.";
  }

  private _delay(ms: number): Promise<void> {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  showFlowIssuesDialog(): void {
    if (!this.flowReviews || this.flowReviews.length === 0) {
      this.toastr.info("No reviews found for this bundle.");
      return;
    }
    const allIssues: any[] = [];
    this.flowReviews.forEach((review) => {
      if (review.hasIssues && review.issues && review.issues.length > 0) {
        review.issues.forEach((issue: any) => {
          allIssues.push({
            ...issue,
            reviewId: review.id || review.rowKey,
            reviewRating: review.rating,
            reviewDate: review.createdDate,
            reviewerName:
              review.createdByUserName ||
              review.createdByFirstName ||
              "Anonymous",
            reviewerEmail:
              review.createdByUserEmail || review.createdByEmail,
            reviewText: review.reviewText,
          });
        });
      }
    });
    if (allIssues.length === 0) {
      this.toastr.info("No issues have been reported for this bundle.");
      return;
    }
    const issuesDialogRef = this.dialog.open(FlowIssuesDialogComponent, {
      width: "900px",
      maxWidth: "95vw",
      maxHeight: "90vh",
      data: {
        flowData: this.bundleData,
        issues: allIssues,
        userData: this.userData,
        isFlowOwner: this.isBundleOwner(),
      },
      panelClass: "dialoguebox",
    });
    issuesDialogRef.afterClosed().subscribe(() => {
      if (this.bundleData?.rowKey) {
        this.loadFlowReviews(this.bundleData.rowKey);
      }
    });
  }

  markReviewHelpful(_review: any): void {
    this.cdr.markForCheck();
  }

  reportReview(review: any): void {
    if (!review) {
      return;
    }
    const userData = JSON.parse(localStorage.getItem("LoggedInUser") || "null");
    if (!userData || !userData.emailAddress) {
      this.toastr.error("Please login to report this review");
      return;
    }
    if (this.bundleData?.rowKey && review.rowKey) {
      this.flowServiceService
        .checkIfUserReportedReview(review.rowKey, this.bundleData.rowKey)
        .pipe(take(1))
        .subscribe(
          (response) => {
            if (response && response.hasReported) {
              this.toastr.info(
                "You have already submitted a report for this review."
              );
              return;
            }
            const dialogRef = this.dialog.open(ReportReviewDialogComponent, {
              width: "520px",
              maxWidth: "95vw",
              data: { review, flowData: this.bundleData },
              panelClass: "dialoguebox",
            });
            dialogRef.afterClosed().subscribe((result) => {
              if (result) {
                this.toastr.info(
                  "Review reported. Thank you for your feedback."
                );
              }
            });
          },
          () => {
            const dialogRef = this.dialog.open(ReportReviewDialogComponent, {
              width: "520px",
              maxWidth: "95vw",
              data: { review, flowData: this.bundleData },
              panelClass: "dialoguebox",
            });
            dialogRef.afterClosed().subscribe((result) => {
              if (result) {
                this.toastr.info(
                  "Review reported. Thank you for your feedback."
                );
              }
            });
          }
        );
    } else {
      const dialogRef = this.dialog.open(ReportReviewDialogComponent, {
        width: "520px",
        maxWidth: "95vw",
        data: { review, flowData: this.bundleData },
        panelClass: "dialoguebox",
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.toastr.info("Review reported. Thank you for your feedback.");
        }
      });
    }
  }

  showReviewsInfo(): void {
    this.toastr.info(
      "Customer reviews help others decide whether this bundle is right for them."
    );
  }

  openDialog() {
    localStorage.setItem("bundleIdToBeDeleted", this.bundleData.rowKey);
    localStorage.setItem("bundleData", JSON.stringify(this.bundleData));
    this.dialog.open(DeleteBundleDialogComponent, {
      panelClass: "confirmation-dialog",
      width: "420px",
      maxWidth: "95vw",
      autoFocus: false,
      restoreFocus: true,
      disableClose: false,
      hasBackdrop: true,
    });
  }

  editBundle(bundleData) {
    const hasDraft = bundleData?.hasPendingDraft ?? bundleData?.HasPendingDraft;
    const isDraftView = bundleData?.isPendingDraftView ?? bundleData?.IsPendingDraftView;
    if (!hasDraft || isDraftView) {
      this.openBundleEditor(bundleData);
      return;
    }

    // Viewers see the published version; editing must continue from the unpublished edits.
    const query = new FlowQueryModel({
      BundleId: bundleData.rowKey,
      userEmail: this.userData?.emailAddress || "",
    });
    this.bundleService.getBundleById(query, true).subscribe({
      next: (data) => this.openBundleEditor(data?.bundleModel || bundleData),
      error: () => this.openBundleEditor(bundleData),
    });
  }

  private openBundleEditor(bundleData) {
    this.bundleEditorLauncher.open(bundleData);
  }

  hasNestedBundleCategories(): boolean {
    const enabled =
      this.bundleData?.enableNestedBundles === true ||
      this.bundleData?.EnableNestedBundles === true;
    const categories =
      this.bundleData?.categories || this.bundleData?.Categories || [];
    return enabled && Array.isArray(categories) && categories.length > 0;
  }

  getBundleCategoriesForView(): any[] {
    const categories =
      this.bundleData?.categories || this.bundleData?.Categories || [];
    if (!Array.isArray(categories)) {
      return [];
    }
    return [...categories].sort(
      (a, b) => (a.order || a.Order || 0) - (b.order || b.Order || 0)
    );
  }

  openNestedBundle(bundle: any): void {
    const rowKey = bundle?.rowKey || bundle?.RowKey;
    if (!rowKey) {
      return;
    }
    this.router.navigate(["/view-guide-pack", rowKey]);
  }

  openCategoryFlow(flow: any): void {
    if (!flow) {
      return;
    }
    this.flowClicked(flow);
  }

  goToQrCode(bundleData) {
    localStorage.setItem("bundleData", JSON.stringify(bundleData));
    // this.router.navigate(["/guide-pack-qrcode"]);
    const dialogRef = this.dialog.open(BundleqrcodeComponent, {
      panelClass: "dialoguebox",
    });
    dialogRef.afterClosed().subscribe((result) => {});
  }

  recordLinkClick(iname) {
    console.log(this.flowData);
    var linkClickDetails = {
      PartitionKey: this.flowData.rowKey,
      Link: iname.wheretofindit,
      LinkTitle: iname.itemkey,
      ContentTitle: this.flowData.title,
      UserEmail: this.userData.emailAddress,
      ContentType: this.flowData.type,
      ContentUrl: this.flowData.url,
    };

    linkClickDetails.Link = iname.wheretofindit;
    linkClickDetails.LinkTitle = iname.itemkey;

    this.flowServiceService
      .postLinkClick(linkClickDetails)
      .subscribe((res) => {});
  }
  openLink(url) {
    if (this.isPurchaseRequired) return;
    else {
      if (url.includes("https://")) {
        url = url;
        window.open(url);
        this.recordLinkClick(url);
      } else {
        url = "https://" + url;
        window.open(url);
        this.recordLinkClick(url);
      }
    }
  }
  openDocument(documentName) {
    if (this.isPurchaseRequired) return;
    window.open(documentName);
  }

  vidEnded(event) {
    var playcount = 0;
    var video = this.videoPlayCounter.filter(
      (v) => v.currentSrc == event.target.currentSrc
    );
    if (video != null) {
      playcount = video.length;
    }

    if (playcount < 3) {
      this.videoPlayCounter.push({
        eventobj: event,
        currentSrc: event.target.currentSrc,
        playcount: playcount,
      });
      event.target.play();
    }
  }

  vidfocus(event) {}

  vidplay(event) {
    if (!this.viewUnloaded) {
      var videos = this.videoPlayCounter.filter((v) => v.id == event.target.id);

      if (videos.length > 3) {
        videos.forEach((element) => {
          var obj = this.videoPlayCounter.indexOf(element);

          if (obj > -1) {
            this.videoPlayCounter.splice(obj, 1);
          }
        });
      }
      event.target.play();
    }
  }

  showVideoFromFile(filePath: string) {
    const mediaUrl = filePath || "";
    const extension = this.getExtension(mediaUrl);
    if (!mediaUrl || !extension) {
      this.showVideo = false;
      this.showVideoOrImage = false;
      this.showImage = true;
      this.imageSource = mediaUrl;
      return;
    }

    this.showVideo = this.isVideoUrl(mediaUrl);
    this.showVideoOrImage = this.showVideo;
    this.showImage = !this.showVideo;
    this.imageSource = mediaUrl;
  }

  onPrimaryVideoError(): void {
    // If preview tries to render as video but source is actually image/unsupported,
    // fallback to image renderer to avoid black screen.
    this.showVideo = false;
    this.showVideoOrImage = false;
    this.showImage = true;
    this.imageSource =
      this.bundleData?.videoThumbNailUrl ||
      this.bundleData?.VideoThumbNailUrl ||
      this.bundleData?.url ||
      this.bundleData?.Url ||
      "";
  }

  saveFlowToServerAccessLevel(AccessType) {
    var bundleModel = {
      Id: this.bundleData.rowKey,
      partitionKey: this.bundleData.partitionKey || this.userData.emailAddress,
      uniqueId: this.bundleData.uniqueId,
      userName: this.bundleData.userName || this.userData.userName || "",
      description: this.bundleData.description || "",
      customerEmail: this.userData.emailAddress,
      title: this.bundleData.title || "",
      accessType: AccessType,
      url: this.bundleData.url || "",
      type: "Bundle",
      bundleStatus: this.bundleData.bundleStatus || "Approved",
      flowIds: this.bundleData.flowIds || [],
      price: this.bundleData.price || 0,
      isPaid: this.bundleData.isPaid || false,
      flowSupportingDocumentsHyperLinkModels:
        this.bundleData.flowSupportingDocumentsHyperLinkModels || [],
      flowSupportingDocumentsDocumentModels:
        this.bundleData.flowSupportingDocumentsDocumentModels || [],
    };
    if (this.userData != null) {
      this.noResultReturned = true;
      this.flowServiceService
        .saveFlowToServerAccessLevel(bundleModel, this.userData.emailAddress)
        .subscribe((data) => {
          this.bundleData.accessType = bundleModel.accessType;
          this.noResultReturned = false;
        });
    }
  }

  restrictedAccessPage(_accessType?: string) {
    const model = {
      ...this.bundleData,
      Type: "Bundle",
      type: "Bundle",
      RowKey: this.bundleData?.rowKey,
      rowKey: this.bundleData?.rowKey,
    };
    localStorage.setItem("flowModel", JSON.stringify(model));
    const dialogRef = this.dialog.open(EnhancedRestrictedAccessComponent, {
      panelClass: "dialoguebox",
      data: { mode: "update", contentType: "bundle" },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        const accessType =
          result.accessType || result.AccessType || this.bundleData.accessType;
        this.bundleData.accessType = accessType;
        this.bundleData.AccessType = accessType;
        this.bundleData.restrictedAccessType =
          result.restrictedAccessType || result.RestrictedAccessType;
        this.bundleData.RestrictedAccessType = this.bundleData.restrictedAccessType;
        this.bundleData.isSearchHidden =
          result.isSearchHidden ?? result.IsSearchHidden;
        this.toastr.success("Bundle access updated successfully.");
      }
    });
  }

  flowByCategory(category) {
    localStorage.setItem("flowByCategoryCategoryName", category);
    this.router.navigate(["/guide-by-category"]);
  }

  openForECode(flowData: any) {
    const dialogRef = this.dialog.open(EmbedforbundlesComponent, {
      panelClass: "dialoguebox",
      width: "520px",
      maxWidth: "95vw",
      data: {
        contentType: "bundle",
        bundleData: flowData || this.bundleData,
        embedContext: { view: "full" },
      } as ShareEmbedDialogData,
    });
    dialogRef.afterClosed().subscribe((result) => {});
  }

  async transferOwnership(bundleData) {
    if (!hasContentCreationPlanAccess(this.userData)) {
      this.toastr.info(
        "A Creator or Business plan is required to transfer ownership."
      );
      return;
    }
    // Check transfer ownership status and open dialog if no active requests
    if (this.bundleData && this.bundleData.rowKey) {
      await this.checkTransferOwnershipStatus(this.bundleData.rowKey);
    } else {
      console.error("Bundle data not available for transfer ownership");
      this.toastr.error("Bundle data not available");
    }
  }

  checkBundleTransferStatus(contentId: string) {
    // For bundles, we don't need to check if they're part of other bundles
    // We can proceed directly to transfer ownership check
    this.checkTransferOwnershipStatus(contentId);
  }

  /**
   * Check if there are any active transfer ownership requests for the current bundle
   * @returns Promise<boolean> - true if there are active requests, false otherwise
   */
  hasActiveTransferRequests(): Promise<boolean> {
    return new Promise((resolve) => {
      if (!this.bundleData || !this.bundleData.rowKey) {
        resolve(false);
        return;
      }

      this.flowServiceService
        .getTransferOwnershipByContentId(this.bundleData.rowKey)
        .subscribe({
          next: (data) => {
            if (data) {
              // Check if there's any request with status other than "Accepted", "Rejected", or "Cancelled"
              const activeRequest =
                data.requestStatus !== "Accepted" &&
                data.requestStatus !== "Rejected" &&
                data.requestStatus !== "Cancelled";

              resolve(!!activeRequest);
            } else {
              resolve(false);
            }
          },
          error: (error) => {
            console.error("Error checking active transfer requests:", error);
            resolve(false); // On error, assume no active requests (fail-safe)
          },
        });
    });
  }

  checkTransferOwnershipStatus(contentId: string) {
    console.log(
      `Checking transfer ownership status for contentId: ${contentId}`
    );

    this.flowServiceService
      .getTransferOwnershipByContentId(contentId)
      .subscribe({
        next: (data) => {
          if (data) {
            // Check if there's any request with status other than "Accepted", "Rejected", or "Cancelled"
            // Statuses that indicate an active/ongoing request: "Pending", "ReworkRequested", "ReworkAccepted", etc.
            // Statuses that indicate a completed request: "Accepted", "Rejected", "Cancelled"
            const activeRequest =
              data.requestStatus !== "Accepted" &&
              data.requestStatus !== "Rejected" &&
              data.requestStatus !== "Cancelled";

            if (activeRequest) {
              console.log(
                `Found active transfer request with status: ${data.requestStatus}`
              );
              // Show info message about transfer request in progress and BLOCK further actions
              this.toastr.warning(
                `Transfer request is already in progress with status: ${data.requestStatus}. Please wait for the current request to be completed before initiating a new one.`
              );
              this.hasActiveTransferRequest = true; // Set the flag to disable transfer actions
              return; // Exit early - do not proceed with any transfer actions
            } else {
              console.log(
                "No active transfer requests found, all requests are completed"
              );
              this.hasActiveTransferRequest = false; // Clear the flag to allow transfer actions
              // Open transfer ownership dialog since no active requests exist
              this.openTransferOwnershipDialog();
            }
          } else {
            console.log("No transfer ownership records found for this content");
            this.hasActiveTransferRequest = false; // Clear the flag to allow transfer actions
            // Open transfer ownership dialog since no records exist
            this.openTransferOwnershipDialog();
          }
        },
        error: (error) => {
          console.error("Error checking transfer ownership status:", error);
          this.hasActiveTransferRequest = false; // On error, assume no active requests (fail-safe)
          // Open transfer ownership dialog on error (fail-safe)
          this.openTransferOwnershipDialog();
        },
      });
  }

  // Do not check/open Transfer Ownership automatically on page load; only via user action
  checkTransferOwnershipOnPageLoad() {
    return; // no-op
  }

  openTransferOwnershipDialog() {
    localStorage.setItem("flowModel", JSON.stringify(this.bundleData));
    const dialogRef = this.dialog.open(TransferOwnershipComponent, {
      panelClass: "dialoguebox",
    });
    dialogRef.afterClosed().subscribe((result) => {
      // if (result) {
      //   this.toastr.success("Successfully ownership is transfer initiated");
      // }
    });
  }

  openBundleTransferWarningDialog() {
    this.dialog.open(BundleTransferWarningDialogComponent, {
      panelClass: "dialoguebox",
      data: { mode: "ongoing-transfer" },
      hasBackdrop: true,
      backdropClass: "non-transparent-backdrop",
    });
  }

  refreshTransferOwnershipStatus() {
    // Refresh the transfer ownership status
    if (this.bundleData) {
      this.checkTransferOwnershipOnPageLoad();
    }
  }

  isTransferOwnershipDisabled(): boolean {
    return (
      this.hasActiveTransferRequest ||
      !hasContentCreationPlanAccess(this.userData)
    );
  }

  onToggleChange(event: any) {
    this.isToggled = event.checked;
  }

  CheckIsUserFollowing() {
    const loggedInEmail = (this.userData?.emailAddress || this.userData?.partitionKey || "").toString().trim();
    const ownerEmail = (
      this.bundleData?.customerEmail ||
      this.bundleData?.partitionKey ||
      this.bundleData?.emailAddress
    ).toString().trim();
    if (this.userData != null) {
      if (
        loggedInEmail &&
        ownerEmail &&
        loggedInEmail.toLowerCase() === ownerEmail.toLowerCase()
      ) {
        this.showFollow = false;
      } else {
        this.showFollow = true;

        const flowModel = {
          UserEmail: ownerEmail,
          FollowerEmail: loggedInEmail,
        };

        this.flowServiceService
          .CheckIsUserFollowing(flowModel)
          .subscribe((data) => {
            const status = (data?.MessageText || data?.messageText || "").toString();
            if (status === "Following") {
              this.followButtonText = "Following";
              this.followingcolor = "#5ea1d8";
              this.followingbgcolor = "white";
            } else {
              this.followButtonText = "Follow";
              this.followingcolor = "white";
              this.followingbgcolor = "#5ea1d8";
            }
          });
      }
    } else {
      // Not logged in: still show Follow button
      this.showFollow = true;
      this.followButtonText = "Follow";
      this.followingcolor = "white";
      this.followingbgcolor = "#5ea1d8";
    }
  }

  followUser() {
    if (this.userData != null) {
      if (this.isFollowLoading) {
        return;
      }
      this.isFollowLoading = true;
      const ownerEmail = (
        this.bundleData?.customerEmail ||
        this.bundleData?.partitionKey ||
        this.bundleData?.emailAddress
      ).toString().trim();
      if (!ownerEmail) {
        this.isFollowLoading = false;
        this.toastr.info("Profile is unavailable.");
        return;
      }
      const flowModel = {
        FollowerEmail: (this.userData?.emailAddress || this.userData?.partitionKey || "").toString().trim(),
        UserEmail: ownerEmail,
      };

      this.flowServiceService.FollowUser(flowModel).subscribe((data) => {
        const nextStatus = (data?.isFollowing || data?.IsFollowing || "").toString().trim().toLowerCase();
        if (nextStatus === "following") {
          this.followButtonText = "Following";
          this.followingcolor = "#5ea1d8";
          this.followingbgcolor = "white";
        } else {
          this.followButtonText = "Follow";
          this.followingcolor = "white";
          this.followingbgcolor = "#5ea1d8";
        }
        this.isFollowLoading = false;
        this.cdr.detectChanges();
        this.CheckIsUserFollowing();
      }, () => {
        this.isFollowLoading = false;
        this.cdr.detectChanges();
      });
    } else {
      localStorage.setItem("returnUrl", this.router.url);
      this.authModalService.openModal('registration', this.router.url);
    }
  }

  onBundleSearchChange() {
    const source =
      this.baseOrderedBundleFlows?.length > 0
        ? this.baseOrderedBundleFlows
        : this.bundleData?.flows || [];
    if (!this.bundleData || !this.bundleData.flows) {
      this.filteredBundleFlows = [];
      return;
    }

    if (!this.bundleSearchText || this.bundleSearchText.trim() === "") {
      this.filteredBundleFlows = [...source];
      return;
    }

    const searchTerm = this.bundleSearchText.toLowerCase().trim();
    this.filteredBundleFlows = source.filter((flow: any) => {
      const title = (flow.title || "").toLowerCase();
      const userName = (flow.userName || "").toLowerCase();
      const uniqueId = (flow.uniqueId || "").toLowerCase();
      const codeLine = (this.bundleFlowCodeDisplay(flow) || "").toLowerCase();

      return (
        title.includes(searchTerm) ||
        userName.includes(searchTerm) ||
        uniqueId.includes(searchTerm) ||
        codeLine.includes(searchTerm)
      );
    });
  }

  clearBundleSearch() {
    this.bundleSearchText = "";
    const source =
      this.baseOrderedBundleFlows?.length > 0
        ? this.baseOrderedBundleFlows
        : this.bundleData?.flows || [];
    if (this.bundleData && this.bundleData.flows) {
      this.filteredBundleFlows = [...source];
    } else {
      this.filteredBundleFlows = [];
    }
  }

  checkIsUserLoggedIn() {
    if (this.userData === null) {
      localStorage.setItem("returnUrl", this.router.url);
      this.authModalService.openModal('registration', this.router.url);
    }
  }

  loadComments() {
    if (!this.bundleData || !this.bundleData.rowKey) return;
    
    this.comments = [];
    var email = "";
    if (this.userData != null && this.userData != undefined) {
      email = this.userData.emailAddress;
    }
    var flowQueryModel = new FlowQueryModel({
      category: "",
      searchString: "",
      userEmail: email,
      pageIndex: 0,
      partitionKey: this.bundleData.rowKey,
    });
    this.flowServiceService
      .getUsersFlowComments(flowQueryModel)
      .subscribe((data) => {
        if (data.flowComments && data.flowComments.length > 0) {
          data.flowComments.forEach((element) => {
            if (
              this.userData &&
              this.userData.emailAddress === element.commentedByUserEmail
            ) {
              element.isFlowOwner = true;
            }
            this.comments.push(element);
          });
        }
      });
  }

  likeComment(comment) {
    if (this.userData != null) {
      const flowModel = {
        PartitionKey: comment.rowKey,
        LikedByUserEmail: this.userData.emailAddress,
        CustomerRowKey: this.userData.rowKey,
      };
      this.flowServiceService.LikeComment(flowModel).subscribe((data) => {
        if (data.isCommentLiked === "liked") {
          comment.isCommentLiked = "liked";
          comment.totalLikedComments = (comment.totalLikedComments || 0) + 1;
        } else if (data.isCommentLiked === "unliked") {
          comment.isCommentLiked = "unliked";
          comment.totalLikedComments = Math.max(
            (comment.totalLikedComments || 0) - 1,
            0
          );
        }
      });
    } else {
      localStorage.setItem("returnUrl", this.router.url);
      this.authModalService.openModal('registration', this.router.url);
    }
  }

  replyToComment(comment) {
    if (!comment) return;
    // Close other reply forms
    if (this.comments && this.comments.length > 0) {
      this.comments.forEach((c) => {
        if (c.childComments) {
          c.childComments.forEach((cc) => {
            cc.isReplyClicked = false;
          });
        }
        if (c !== comment) {
          c.isReplyClicked = false;
        }
      });
    }
    this.reply = "";
    comment.isReplyClicked = true;
  }

  isAddingComment: boolean = false;

  addComment(event?: Event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (this.isAddingComment) {
      return;
    }

    if (
      this.userData != null &&
      !this.bundleData.isFlowPurchased &&
      this.bundleData.price != null &&
      this.bundleData.isPaid &&
      this.userData.emailAddress !== this.bundleData.customerEmail
    ) {
      this.toastr.success("To add comment please purchase bundle");
      localStorage.setItem("checkoutFlow", JSON.stringify(this.bundleData));
      this.router.navigate(["/checkout"]);
      return;
    }

    const commentText = this.commentsForm.get("Comment")?.value;
    if (commentText && commentText.trim().length > 0) {
      this.isAddingComment = true;
      this.noResultReturned = true;
      const commentModel = {
        FlowId: this.bundleData.rowKey,
        CommentedByUserEmail: this.userData.emailAddress,
        Comment: commentText.trim(),
        ParentCommentId: null,
        FlowType: 2, // Bundle type
      };
      this.flowServiceService.addComment(commentModel).subscribe(
        (data) => {
          this.isAddingComment = false;
          this.noResultReturned = false;
          this.commentsForm.get("Comment")?.setValue("");
          this.toastr.success("Comment added successfully");
          this.loadComments();
        },
        (error) => {
          this.isAddingComment = false;
          this.noResultReturned = false;
        }
      );
    }
  }

  addReply(comment) {
    if (
      this.userData != null &&
      !this.bundleData.isFlowPurchased &&
      this.bundleData.price != null &&
      this.bundleData.isPaid &&
      this.userData.emailAddress !== this.bundleData.customerEmail
    ) {
      this.toastr.success("To add comment please purchase bundle");
      localStorage.setItem("checkoutFlow", JSON.stringify(this.bundleData));
      this.router.navigate(["/checkout"]);
      return;
    }

    if (this.reply && this.reply.length > 0) {
      comment.isReplyClicked = false;
      this.noResultReturned = true;
      const commentModel = {
        FlowId: this.bundleData.rowKey,
        CommentedByUserEmail: this.userData.emailAddress,
        Comment: this.reply,
        ParentCommentId:
          comment.parentCommentId == null
            ? comment.rowKey
            : comment.parentCommentId,
        FlowType: 2, // Bundle type
      };
      this.flowServiceService.addComment(commentModel).subscribe((data) => {
        this.noResultReturned = false;
        this.reply = "";
        this.replyForm.get("reply")?.setValue("");
        this.toastr.success("Reply added successfully");
        this.loadComments();
      });
    }
  }

  editComment(comment) {
    this.dataService.changeMessage(comment);
    this.router.navigate(["/edit-comment"]);
  }

  deleteComment(comment) {
    var flowQueryModel = new FlowQueryModel({
      rowKey: comment.rowKey,
    });

    this.noResultReturned = true;
    this.flowServiceService.deleteComment(flowQueryModel).subscribe((data) => {
      this.noResultReturned = false;
      this.toastr.success("Comment deleted successfully");
      this.loadComments();
    });
  }
}
